export const NAME_FIELD = 'name';
export const PROFILE_NAME_FIELD = 'profileName';
export const ODDITIONAL_NAME_FIELD = 'OdditionalName';
export const DESCRIPTION_FIELD = 'description';
export const EAP_TYPE_FIELD = 'eapType';
export const AUTH_CERTIFICATE_FIELD = 'authCertificate';
export const PSK_FIELD = 'psk';
export const USERNAME_FIELD = 'username';
export const PASSWORD_FIELD = 'password';
export const IS_DEFAULT_FIELD = 'isDefault';
export const AGENTS_FIELD = 'agents';

export const IS_DEFAULT_TRANSLATED_FIELD = 'isDefaultTranslated';
export const CONFIGURED_AGENTS_COUNT_FIELD = 'configuredAgentsCount';

export const EAP_TYPE_OPTIONS = {
    eapTls: 'EAP-TLS',
    peapMschapV2: 'PEAP-MSCHAP-V2',
};

export const AUTH_CERTIFICATE_DEFAULT_OPTION = 'None';

export const NETWORKS_IN_USE_ERROR = 'network_in_use';
